module.exports = __webpack_public_path__ + "img/rectangular-brown-wooden-table-with-chairs-beside-wall-3264486.f4ed824d.jpg";